import React from "react";
import { connect, useDispatch } from "react-redux";
import { selectors as softTokenSelectors } from "reducers/softToken";
import { selectors as sessionSelectors } from "reducers/session";
import Button from "pages/_components/Button";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import { Grid, Row } from "react-bootstrap";
import { bool, string, arrayOf, shape } from "prop-types";
import Accordion from "pages/_components/Accordion";
import AccordionItem from "pages/_components/AccordionItem";
import { actions as loansActions, selectors as loansSelectors } from "reducers/loans";

import FormattedAmount from "pages/_components/FormattedAmount";
import CustomText from "pages/_components/CustomText/CustomText";

const CuotasDetail = (props) => {
    const { fetchingDownload, handleExpandEndorsement, installmentList } = props;

    const dispatch = useDispatch();

    const handleDownload = () => {
        dispatch(loansActions.downloadLoansDetail(installmentList, "pdf"));
    };

    return (
        <div className="container full-width">
            <article className="container transaction-ticket accounts__details">
                <Grid>
                    <Row>
                        <h2 className="title-content">
                            <CustomText text="loans.detail.title" textType="I18N" />
                        </h2>
                        <GridTable>
                            <GridTable.Container className="box box-shadow accounts__details-box" columns={1} rows={10}>
                                {installmentList &&
                                    Array.isArray(installmentList) &&
                                    installmentList.map((value) => (
                                        <>
                                            <CustomData
                                                titleText={`Cuota ${value.number} - ${value.paymentDueDate}`}
                                                titleTextType="STRING"
                                                titleClass="loans-title-accordion"
                                            />
                                            <Accordion key={value.number} numberToExpand={1}>
                                                <AccordionItem
                                                    key={value.number}
                                                    number={value.number}
                                                    toggleAccordion={() => handleExpandEndorsement}
                                                    item={<FormattedAmount currency="ARS" quantity={value.totalFee} />}
                                                    titleClasses="loans-h2-accordion"
                                                    buttonClassName="totalFeeInputStyle">
                                                    <GridTable className="information">
                                                        <>
                                                            <GridTable.Container columns={2}>
                                                                <GridTable.Data columnStart={1} rowStart={1}>
                                                                    <CustomData
                                                                        titleText="loans.amortization.label"
                                                                        titleTextType="I18N"
                                                                        titleClass="text-Primary-primary-color"
                                                                        valueText={`$${value.capital}`}
                                                                    />
                                                                </GridTable.Data>
                                                                <GridTable.Data columnStart={2} rowStart={1}>
                                                                    <CustomData
                                                                        dataClass="with-background"
                                                                        titleText="loans.interest.label"
                                                                        titleTextType="I18N"
                                                                        titleClass="text-Primary-primary-color"
                                                                        valueText={`$${value.installmentInterestDue}`}
                                                                    />
                                                                </GridTable.Data>
                                                                <GridTable.Data columnStart={1} rowStart={2}>
                                                                    <CustomData
                                                                        titleText="loans.iva.label"
                                                                        titleTextType="I18N"
                                                                        titleClass="text-Primary-primary-color"
                                                                        valueText={`$${value.iva}`}
                                                                    />
                                                                </GridTable.Data>
                                                                <GridTable.Data columnStart={2} rowStart={2}>
                                                                    <CustomData
                                                                        titleText="loans.perception.iva.label"
                                                                        titleTextType="I18N"
                                                                        titleClass="text-Primary-primary-color"
                                                                        valueText={`$${value.ivaPerception}`}
                                                                    />
                                                                </GridTable.Data>
                                                                <GridTable.Data columnStart={1} rowStart={3}>
                                                                    <CustomData
                                                                        dataClass="with-background"
                                                                        titleText="loans.stamps.label"
                                                                        titleTextType="I18N"
                                                                        titleClass="text-Primary-primary-color"
                                                                        valueText={`$${value.stampTax}`}
                                                                    />
                                                                </GridTable.Data>
                                                                <GridTable.Data columnStart={2} rowStart={3}>
                                                                    <CustomData
                                                                        dataClass="with-background"
                                                                        titleText="loans.jurisdiction.stamps.label"
                                                                        titleTextType="I18N"
                                                                        titleClass="text-Primary-primary-color"
                                                                        valueText={value.jurisdictionStamp}
                                                                    />
                                                                </GridTable.Data>

                                                                <GridTable.Data columnStart={1} rowStart={4}>
                                                                    <CustomData
                                                                        dataClass="with-background"
                                                                        titleText="loans.perception.iibb.label"
                                                                        titleTextType="I18N"
                                                                        titleClass="text-Primary-primary-color"
                                                                        valueText={`$${value.iibbAmount}`}
                                                                    />
                                                                </GridTable.Data>
                                                                <GridTable.Data columnStart={2} rowStart={4}>
                                                                    <CustomData
                                                                        dataClass="with-background"
                                                                        titleText="loans.jurisdiction.iibb.label"
                                                                        titleTextType="I18N"
                                                                        titleClass="text-Primary-primary-color"
                                                                        valueText={value.jurisdictioniibb}
                                                                    />
                                                                </GridTable.Data>
                                                            </GridTable.Container>
                                                        </>
                                                    </GridTable>
                                                </AccordionItem>
                                            </Accordion>
                                        </>
                                    ))}
                            </GridTable.Container>
                            <div style={{ paddingBottom: 20 }}>
                                <Button
                                    className="btn-primary no-print"
                                    image="images/figma/icon/download.svg"
                                    label="global.download"
                                    onClick={handleDownload}
                                    fetching={fetchingDownload}
                                    block
                                />
                            </div>
                        </GridTable>
                    </Row>
                </Grid>
            </article>
        </div>
    );
};

CuotasDetail.propTypes = {
    fetchingDownload: bool.isRequired,
    handleExpandEndorsement: string.isRequired,
    installmentList: arrayOf(shape({})),
};

CuotasDetail.defaultProps = {
    installmentList: [],
};

const mapStateToProps = (state) => ({
    fetchingDownload: loansSelectors.getFetchingDownload(state),
    tokenInfo: softTokenSelectors.getTokenInfo(state),
    deviceStatus: softTokenSelectors.getDeviceStatus(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});

export default connect(mapStateToProps)(CuotasDetail);
